import labels from './labels';

export const steps = Object.freeze({
  OTP: {
    name: 'otp',
    header: 'OTP has been sent to your e-mail address.',
    stepNo: 1,
  },
  ACCOUNT: {
    name: 'account',
    header: `Create your ${labels.FX_EXPRESS} Account`,
    stepNo: 2,
  },
  CREDENTIALS: {
    name: 'credentials',
    header: `Create your ${labels.FX_EXPRESS} Login User ID and Password`,
    stepNo: 3,
  },
  ERROR: {
    name: 'error',
    header: 'Error',
  },
});
